import axios, {AxiosResponse} from 'axios'
import {REACT_APP_API_BASE_URL} from '../../../../config/keys'
import toast from 'react-hot-toast'
import {useAuth} from '../../auth'

export interface Voice {
  languageCodes: [string]
  name: string
  ssmlGender: Gender
}

export interface VoiceResponse {
  voices: Voice[]
}

export interface GoogleAudioResponse {
  audioContent: string
}

export interface OutageStatus {
  status: 'running' | 'fault'
  text: string
}

export type Gender = 'MALE' | 'FEMALE' | 'NEUTRAL'

export async function getGenders(
  languageCode: string,
  languageName: string,
  token?: string
): Promise<Gender[]> {
  try {
    const response: AxiosResponse<VoiceResponse> = await axios.get(
      `${REACT_APP_API_BASE_URL}/api/tts/voices?language=${languageCode}`,
      {headers: {'x-auth-token': token}}
    )

    const genders: Gender[] = []

    response.data.voices.forEach((voice) => {
      if (!genders.includes(voice.ssmlGender) && voice.name === languageName)
        genders.push(voice.ssmlGender)
      // if (!genders.includes(voice.ssmlGender)) genders.push(voice.ssmlGender)
    })
    return genders
  } catch (err) {
    console.log(err)
    return []
  }
}

export async function getLanguages(languageCode: string, token): Promise<string[]> {
  try {
    const response: AxiosResponse<VoiceResponse> = await axios.get(
      `${REACT_APP_API_BASE_URL}/api/tts/voices?language=${languageCode}`,
      {headers: {'x-auth-token': token}}
    )

    const languages: string[] = []

    response.data.voices.forEach((voice) => {
      if (!languages.includes(voice.name)) languages.push(voice.name)
      // if (!genders.includes(voice.ssmlGender)) genders.push(voice.ssmlGender)
    })
    return languages
  } catch (err) {
    console.log(err)
    return []
  }
}

export async function getLanguageCodes(token?: string): Promise<string[]> {
  try {
    const response: AxiosResponse<VoiceResponse> = await axios.get(
      `${REACT_APP_API_BASE_URL}/api/tts/voices`,
      {headers: {'x-auth-token': token}}
    )

    const languageCodes: string[] = []

    response.data.voices.forEach((voice) => {
      if (!languageCodes.includes(voice.languageCodes[0]))
        languageCodes.push(voice.languageCodes[0])
    })
    return languageCodes
  } catch (err) {
    console.log(err)
    return []
  }
}

export async function getCurrentOutage() {
  try {
    const response: any = await fetch(`${REACT_APP_API_BASE_URL}/api/tts/outage`, {
      method: 'GET',
    })
    console.log(response)
    if (response.ok) {
      const blob = await response?.blob()
      return {success: true, blob}
    } else {
      return {success: false}
    }
  } catch (err: any) {
    console.log(err)
    return {success: false}
  }
}

export async function getCurrentOutageStatus() {
  try {
    const response: AxiosResponse<OutageStatus> = await axios.get(
      `${REACT_APP_API_BASE_URL}/api/tts/outagestatus`
    )
    const outageStatus = response.data
    return outageStatus
  } catch (err) {
    console.log(err)
  }
}

export async function saveOutage(text: string, token) {
  try {
    const response: any = await fetch(`${REACT_APP_API_BASE_URL}/api/tts/outage`, {
      method: 'POST',
      body: JSON.stringify({text}),
      headers: {'Content-Type': 'application/json', 'x-auth-token': token},
    })

    if (response.ok) {
      const blob = await response?.blob()

      return {success: true, blob, text, status: 'fault'}
    } else {
      return {success: false}
    }
  } catch (error: any) {
    return {success: false}
  }
}

export async function deleteCurrentOutage(token?: string) {
  await axios.delete(`${REACT_APP_API_BASE_URL}/api/tts/outage`, {headers: {'x-auth-token': token}})
}

export async function textToSpeech(
  token,
  text: string,
  languageCode: string,
  languageName: string,
  ssmlGender: Gender,
  pitch: number,
  speakingRate: number
) {
  const requestPayload = {
    input: {
      text: text,
    },
    voice: {
      languageCode,
      name: languageName,
      ssmlGender,
    },
    audioConfig: {
      pitch,
      speakingRate,
      audioEncoding: 'LINEAR16', // You can choose other formats like MP3 or WAV
    },
  }

  try {
    const response: any = await fetch(`${REACT_APP_API_BASE_URL}/api/tts/synthesize`, {
      method: 'POST',
      body: JSON.stringify(requestPayload),
      headers: {'Content-Type': 'application/json', 'x-auth-token': token},
    })
    const blob = await response?.blob()
    return blob
  } catch (error: any) {
    console.log(error)
  }
}

export async function downlodFile() {
  try {
    await fetch(`${REACT_APP_API_BASE_URL}/api/tts/download`, {
      method: 'GET',
    })
  } catch (err) {
    console.log(err)
  }
}

// Example usage
// async function main() {
//   const audioContent = textToSpeech('', '', '', '')
//   if (audioContent) {
//     fs.writeFileSync('voice.wav', Buffer.from(audioContent, 'base64'))
//     // console.log(`Audio saved to ${fileName}`);
//   } else {
//     console.error('Failed to generate audio content.')
//   }
// }

// main();
